import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import AuditoriaFilter from './components/AuditoriaFilter';

export default function AuditoriaAdmin() {

    return (
        <MainContent component={ <AuditoriaFilter /> } titulo='Administración de Auditoria' />        
    );

};